module.exports = __webpack_public_path__ + "static/img/326.237144a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/326.png
// module id = D88K
// module chunks = 0